import React from 'react';
import { Box } from '@marvelapp/ui';
import { SpecsPanel, SpecsPanelLabel } from '@marvelapp/ui-internal';
import PanelSwatchLong from './PanelSwatchLong';
export default function PanelTextFill(_a) {
    var color = _a.color;
    return (React.createElement(SpecsPanel, { title: "Fill" },
        React.createElement(SpecsPanelLabel, null, "Colour"),
        React.createElement(Box, { marginTop: "4px" },
            React.createElement(PanelSwatchLong, { color: color }))));
}
